import scrollMonitor from 'scrollmonitor'
import select from 'dom-select'
import { set } from 'lib/util'

class AboutHistory {
  constructor (el) {
    this.el = el
    this.hasRun = false
    this.years = select.all('[data-year]', this.el)
    this.watcher = scrollMonitor.create(this.el, -1 * window.innerHeight * 0.5)
    this.watcher.enterViewport(this.onEnterView.bind(this))
  }

  onEnterView () {
    if (this.hasRun) return false
    let timer = 100
    Array.from(this.years).forEach((el) => {
      setTimeout(() => {
        set(el, 'is-visible')
      }, timer)
      timer += 550
    })
    this.hasRun = true
  }
}
export default el => new AboutHistory(el)
